<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M405 559v378h109V391h-94c-10 61-56 93-137 97v71h122zm311 0v378h108V391h-94c-10 61-56 93-137 97v71h123zM599 124c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528z" />
  </svg>
</template>
